import Carousel from './carousel';

const DESCRIPTIVE_GALLERY_OPTIONS = {
    cellSelector: '.descriptive-gallery__slide',
    cellAlign: 'left',
    contain: true,
    wrapAround: false,
    pageDots: true,
    prevNextButtons: true,
    imagesLoaded: true,
};

class DescriptiveGallery {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carousel = null;
    }

    init() {
        let self = this;

        if (!self.elem) return self;

        self.carousel = new Carousel(self.elem, DESCRIPTIVE_GALLERY_OPTIONS).init();

        if (self.carousel && self.carousel.flickity) {
            const flickityInstance = self.carousel.flickity;
            const pageDots = self.elem.querySelector('.flickity-page-dots');
            const formatCount = (index) => String(index + 1).padStart(2, '0');

            const updateSlideCount = () => {
                if (!pageDots) return;
                pageDots.setAttribute('data-current-slide', formatCount(flickityInstance.selectedIndex));
            };

            flickityInstance.on('ready', updateSlideCount);
            flickityInstance.on('change', updateSlideCount);
            updateSlideCount();
        }

        return self;
    }
}

export default DescriptiveGallery;
